export const uiActionTypes = {
    OPEN_CART_SIDEBAR: 'OPEN_CART_SIDEBAR',
    CLOSE_CART_SIDEBAR: 'CLOSE_CART_SIDEBAR'
};
